const single_sign_on = {
    forbidden_domains: 'Les domaines de messagerie publique ne sont pas autorisés.',
    duplicated_domains: 'Il existe des domaines en double.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
